import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Message } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import Validator from "validator";
import isLength from "validator/lib/isLength";
import matches from "validator/lib/matches";
import isEmpty from "lodash/isEmpty";
import axios from "axios";

class ResetPasswordForm extends React.Component {
  state = {
    data: {
      token: "",
      password: "",
      passwordConfirmation: "",
    },
    passwordConfiguration: {},
    isLoading: false,
    errors: {},
  };

  componentDidMount() {
    
    this.setState({
      data: { ...this.state.data, token: this.props.token },
    });

    this.getPasswordConfiguration();
  }

  getPasswordConfiguration = () => {
    axios.get(`/api/passwordConfigurations/getOne`)
    .then((resp) => this.setState({ passwordConfiguration: resp.data.resp }))
    .catch((err) => "Error en consulta: " + err);
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state.data);

    if (!isValid) {
      this.setState({ errors: errors });
    }

    return isValid;
  }

  validateInput(data) {

    const { passwordConfiguration } = this.state;
  
    let errors = {};
    
    const cantidadMinimaCaracteres = passwordConfiguration.longitud_minima;
  
    const cantidadNumeros = passwordConfiguration.cantidad_numeros;
    const regExpCantidadNumeros = new RegExp(`[0-9]{${cantidadNumeros}}`);
  
    const cantidadLetras = passwordConfiguration.cantidad_letras;
    const regExpCantidadLetras = new RegExp(`[a-z]{${cantidadLetras}}`, 'i');
  
    const cantidadMayusculas = passwordConfiguration.cantidad_mayusculas;
    const regExpCantidadMayusculas = new RegExp(`[A-Z]{${cantidadMayusculas}}`);
  
    const cantidadMinusculas = passwordConfiguration.cantidad_minusculas;
    const regExpCantidadMinusculas = new RegExp(`[a-z]{${cantidadMinusculas}}`);
  
    const cantidadCaracteresEspeciales = passwordConfiguration.cantidad_caracteres_especiales;
    const regExpCantidadCaracteresEspeciales = new RegExp('[!@#$%^&*()_+\\-=\\[\\]{};\'":\\\\|,.<>\\/?~]{' + cantidadCaracteresEspeciales + '}');
  
    if (Validator.isEmpty(data.passwordConfirmation)) {
      errors.passwordConfirmation = "Este campo es requerido.";
    }
  
    if (!Validator.equals(data.password, data.passwordConfirmation)) {
      errors.passwordConfirmation = "Las contraseñas no son iguales";
    }
  
    /** SPRINT #45 - SCS */
  
    if (!regExpCantidadCaracteresEspeciales.test(data.password)) {
      errors.password = `La contraseña debe tener al menos ${cantidadCaracteresEspeciales} caracter(es) especial(es).`;
    }
  
    if (!regExpCantidadMinusculas.test(data.password)) {
      errors.password = `La contraseña debe tener al menos ${cantidadMinusculas} letra(s) minúscula(s).`;
    }
  
    if (!regExpCantidadMayusculas.test(data.password)) {
      errors.password = `La contraseña debe tener al menos ${cantidadMayusculas} letra(s) mayúscula(s).`;
    }
  
    if (!regExpCantidadLetras.test(data.password)) {
      errors.password = `La contraseña debe tener al menos ${cantidadLetras} letra(s).`;
    }
  
    if (!regExpCantidadNumeros.test(data.password)) {
      errors.password = `La contraseña debe tener al menos ${cantidadNumeros} número(s).`;
    }
  
    if (data.password.length < cantidadMinimaCaracteres) {
      errors.password = `La contraseña debe contener al menos ${cantidadMinimaCaracteres} caracteres.`;
    }
  
    if (Validator.isEmpty(data.password)) {
      errors.password = "Este campo es requerido.";
    }
  
   /** SPRINT #45 - SCS */
  
    /*if (!isLength(data.password, { min: 12, max: 30 })) {
      errors.password = "La contraseña debe contener de 12 a 30 caracteres";
    } else {
      if (
        !matches(
          data.password,
          /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?['\/~`!@#$%^&*()_\-+={}[]|;:"<>,.?\\]).{12,30}$/g
        )
      ) {
        errors.password = `La contraseña debe estar compuesta por al menos 1 mayúscula, 1 minúscula, 4 números y 1 caracter especial`;
      }
    }*/
  
    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  onSubmit = () => {
    if (this.isValid()) {
      this.setState({ isLoading: true });
      this.props.submit(this.state.data).catch((err) => {
        if (err.response.status >= 500) {
          this.setState({
            errors: {
              global: "No se pudo contactar con el servidor",
            },
            isLoading: false,
          });
        } else if (err.response.status === 404) {
          this.setState({
            errors: {
              global: "Ups!, Algo esta mal",
            },
            isLoading: false,
          });
        } else {
          this.setState({
            errors: err.response.data.errors,
            isLoading: false,
          });
        }
      });
    }
  };

  validate = (data) => {
    const errors = {};
    // TODO: validate uniqueness.
    if (!data.username) errors.username = "No puede estar en blanco.";
    if (!data.password) errors.password = "No puede estar en blanco.";
    if (!Validator.isemail_address(data.email_address))
      errors.email_address = "Debe ser un correo válido";
    return errors;
  };

  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  render() {
    const { data, errors, isLoading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={isLoading}>
        {errors.global && (
          <Message negative>
            <Message.Header>Algo salió mal.</Message.Header>
            <p>{errors.global}</p>
          </Message>
        )}

        <Form.Field error={!!errors.password}>
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            name="password"
            value={data.password}
            onChange={this.onChange}
            autoComplete="off"
          />
          {errors.password && <InlineError text={errors.password} />}
        </Form.Field>
        <Form.Field error={!!errors.passwordConfirmation}>
          <label htmlFor="passwordConfirmation">Confirmar contraseña</label>
          <input
            type="password"
            id="passwordConfirmation"
            name="passwordConfirmation"
            value={data.passwordConfirmation}
            onChange={this.onChange}
            autoComplete="off"
          />
          {errors.passwordConfirmation && (
            <InlineError text={errors.passwordConfirmation} />
          )}
        </Form.Field>
        <Button color="blue">Modificar contraseña</Button>
      </Form>
    );
  }
}

ResetPasswordForm.propTypes = {
  submit: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
